var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeRingFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 391,
    viewBox: "0 0 390 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195 70.5C125.964 70.5 70 126.464 70 195.5C70 264.536 125.964 320.5 195 320.5C264.036 320.5 320 264.536 320 195.5C320 126.464 264.036 70.5 195 70.5ZM0 195.5C0 87.8045 87.3045 0.5 195 0.5C302.696 0.5 390 87.8045 390 195.5C390 303.196 302.696 390.5 195 390.5C87.3045 390.5 0 303.196 0 195.5Z",
    fill: "#00CDD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeRingFill);
export default __webpack_public_path__ + "static/media/shape-ring-fill.718a85c6.svg";
export { ForwardRef as ReactComponent };